import { useAppDetails } from 'hooks/useAppDetails';
import { getAppLogoAlt } from 'utils/organization';
import { StyledImage } from './AppLogo.styles';

export default function AppLogo() {
    const appDetails = useAppDetails();
    const customLogo = process.env.REACT_APP_ORG_LOGO;
    return (
        <StyledImage
            logoHeight={process.env.REACT_APP_AUTH_LOGO_HEIGHT ?? ''}
            logoWidth={process.env.REACT_APP_AUTH_LOGO_WIDTH ?? ''}
            appName={appDetails.name}
            alt={getAppLogoAlt(appDetails.name)}
            src={customLogo || appDetails.logo}
        />
    );
}
